module.exports = __webpack_public_path__ + "img/icon-footer-social-in.c9dc65a5.svg";